import React, { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { auth } from '../firebase';
import { signOut } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import './SidebarMenu.css';
import {
    FaTachometerAlt, FaFileInvoice, FaListUl, FaChartLine, FaCalculator, FaSignOutAlt, FaMobileAlt
} from 'react-icons/fa';

const SidebarMenu = ({ isMobile, isOpen, toggleSidebar }) => {
    const location = useLocation();

    const user = auth.currentUser;

    const menuItems = [
        { icon: <FaTachometerAlt />, label: 'Sayaç Tanımları', path: '/main-meters' },
        { icon: <FaFileInvoice />, label: 'Fatura Girişi', path: '/add-invoice' },
        { icon: <FaListUl />, label: 'Faturalar', path: '/invoices' },
        { icon: <FaChartLine />, label: 'Sayaç Okuma Girişi', path: '/add-meter-reading' },
        { icon: <FaChartLine />, label: 'Sayaç Tüketim Tarihçesi', path: '/meter-reading-list-timeline' },
        { icon: <FaChartLine />, label: 'Sayaç Okuma Sonuçları', path: '/meter-readings' },
        { icon: <FaCalculator />, label: 'Süzme Sayaçları Faturala', path: '/allocate-invoice' },
        { icon: <FaCalculator />, label: 'Hesaplama Formu', path: '/free-rating-stepper' }
    ];

    return (
        <div className={`sidebar ${isMobile ? (isOpen ? 'open' : 'closed') : ''}`}>
            <div className="menu-items">
                {menuItems.map((item) => (
                    <NavLink
                        key={item.path}
                        to={item.path}
                        className={({ isActive }) =>
                            `menu-link${isActive ? ' active' : ''}`
                        }
                        onClick={() => {
                            if (isMobile) toggleSidebar();
                        }}
                    >
                        {item.icon}
                        <span>{item.label}</span>
                    </NavLink>
                ))}
            </div>

            {/* Mobil Uygulama Kartı */}
            <div style={{
                marginTop: 'auto',
                padding: '10px 8px',
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                borderRadius: '12px',
                margin: '15px',
                textAlign: 'center'
            }}>
                <div style={{ marginBottom: '5px', color: '#ffffff' }}>
                    <FaMobileAlt size={24} />
                </div>
                <div>
                    <h4 style={{ 
                        fontSize: '16px', 
                        fontWeight: '600', 
                        margin: '0 0 5px 0', 
                        color: '#ffffff' 
                    }}>Mobil Uygulama</h4>
                    <div style={{ 
                        display: 'flex', 
                        flexDirection: 'column', 
                        gap: '8px', 
                        alignItems: 'center' 
                    }}>
                        <a 
                            href="https://apps.apple.com/app/süzme-sayaç/id6751746732" 
                            target="_blank" 
                            rel="noopener noreferrer"
                            style={{ 
                                display: 'inline-block', 
                                transition: 'transform 0.2s' 
                            }}
                        >
                            <img 
                                src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/tr-tr?size=250x83" 
                                alt="App Store'dan İndir"
                                style={{ height: '32px' }}
                            />
                        </a>
                        <div style={{ position: 'relative', display: 'inline-block' }}>
                            <img 
                                src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg" 
                                alt="Yakında"
                                style={{ height: '32px', opacity: 0.4 }}
                            />
                            <span style={{
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                background: 'rgba(0, 0, 0, 0.8)',
                                padding: '3px 10px',
                                borderRadius: '4px',
                                fontSize: '10px',
                                fontWeight: 'bold',
                                color: '#ffffff',
                                whiteSpace: 'nowrap'
                            }}>Yakında</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SidebarMenu;